import React from 'react';
import { Link } from 'react-router-dom';

interface FooterProps {
  className?: string;
  children?: React.ReactNode;
}

export const Footer: React.FC<FooterProps> = ({ className, children }) => {
  return (
    <footer className={`bg-white border-t border-gray-200 ${className}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="text-center">
          <p className="text-gray-600 text-sm mb-2">
            © 2025 少儿AI编程学习平台. 让AI学习变得简单有趣
          </p>
          <div className="flex justify-center space-x-4">
            <Link to="/privacy" className="text-xs text-gray-500 hover:text-gray-700">
              隐私政策
            </Link>
            <Link to="/terms" className="text-xs text-gray-500 hover:text-gray-700">
              服务条款
            </Link>
            <Link to="/contact" className="text-xs text-gray-500 hover:text-gray-700">
              联系我们
            </Link>
          </div>
          <div className="mt-2 text-xs text-gray-500">
            <a
              href="https://beian.miit.gov.cn/"
              target="_blank"
              rel="noopener noreferrer"
              className="underline"
            >
              京ICP备2025152547号
            </a>
          </div>
        </div>
        {children}
      </div>
    </footer>
  );
};
